import {makeReactContext} from 'lib/makeReactContext';
import {Method, ParameterUsages, ProcedureStepGroupType} from 'procedures/ProcedureDomainTypes';

export type ParameterSettings = Pick<
  Method,
  'dataParameterSettings' | 'materialInputSettings' | 'materialOutputSettings' | 'equipmentSettings'
>;
export interface ProcedureStepConfigEditorContextValue {
  parameterSettings: ParameterSettings;
  parameterUsages: ParameterUsages;
  currentStepGroup: ProcedureStepGroupType | null;
}

/**
 * A subset of the StepConfigEditor props to allow for accessibility within Documents. Be wary of adding
 * values that will change frequently.
 */
export const ProcedureStepConfigEditorContext = makeReactContext<
  ProcedureStepConfigEditorContextValue | undefined
>(() => undefined, 'ProcedureStepConfigEditorContext');
